import {Three as THREE} from "@cm/material-nodes/three"

export type ThreeLightWithShadow = THREE.Light & {shadow?: THREE.LightShadow}

export type OriginalObjectRenderData = {
    parent: THREE.Object3D | null
}

export const getOriginalObjectRenderData = (object: THREE.Object3D): OriginalObjectRenderData => {
    return {
        parent: object.parent,
    }
}

export const restoreOriginalObjectRenderData = (object: THREE.Object3D, originalData: OriginalObjectRenderData) => {
    const {parent} = originalData
    if (parent) parent.attach(object)
    else object.parent = null
}

export type OriginalMeshRenderData = {
    material: THREE.Material | THREE.Material[]
    visible: boolean
    frustrumCulled: boolean
}

export type OriginalLightRenderData = {
    shadowMapAutoUpdate?: boolean
    shadowMapNeedsUpdate?: boolean
}

export const getOriginalMeshRenderData = (mesh: THREE.Mesh): OriginalMeshRenderData => {
    return {
        material: mesh.material,
        visible: mesh.visible,
        frustrumCulled: mesh.frustumCulled,
    }
}

export const getOriginalLightRenderData = (light: THREE.Light): OriginalLightRenderData => {
    const shadowLight = light as ThreeLightWithShadow
    return {
        shadowMapAutoUpdate: shadowLight.shadow?.autoUpdate,
        shadowMapNeedsUpdate: shadowLight.shadow?.needsUpdate,
    }
}

export const restoreOriginalMeshRenderData = (mesh: THREE.Mesh, originalData: OriginalMeshRenderData) => {
    const {material, visible, frustrumCulled} = originalData

    mesh.material = material
    mesh.visible = visible
    mesh.frustumCulled = frustrumCulled
}

export const restoreOriginalLightRenderData = (light: THREE.Light, originalData: OriginalLightRenderData) => {
    const {shadowMapAutoUpdate, shadowMapNeedsUpdate} = originalData
    const shadowLight = light as ThreeLightWithShadow
    if (shadowLight.shadow) {
        if (shadowMapAutoUpdate !== undefined) shadowLight.shadow.autoUpdate = shadowMapAutoUpdate
        if (shadowMapNeedsUpdate !== undefined) shadowLight.shadow.needsUpdate = shadowMapNeedsUpdate
    }
}
